import { Page, QueryBase } from "../../../shared/models/models";
import { CustomerCompanyDetails } from "../../companies/models/models";

export interface CustomerCompanyGroupsState {
  query: CompanyGroupsQuery;
  companyGroups?: Page<CompanyGroup>;
  companyGroup?: CompanyGroup;
  companyGroupItemsQuery: CompanyGroupItemsQuery;
  companyGroupItems?: Page<GroupItem>;
  loading: boolean;
  success?: string;
  error: any;
}

export interface CompanyGroup {
  id: string;
  name: string;
  createdDate: string;
  items: GroupItem[];
}

export interface ChangeCompanyGroup {
  name: string;
  customerIds: string[];
}

export interface GroupItem {
  id: string;
  customer?: CustomerCompanyDetails;
}

export interface CompanyGroupsQuery extends QueryBase<CompanyGroupsQueryParameter> {
}

export enum CompanyGroupsQueryParameter {
  name = 1,
  createdDate = 2,
  modifiedDate = 3
}

export interface CompanyGroupItemsQuery extends QueryBase<CompanyGroupItemsQueryParameter> {
}

export enum CompanyGroupItemsQueryParameter {
  createdDate = 1,
  modifiedDate = 2,
  name = 3
}
